angular.module('SpidApp')

.constant('ComplementServiceAffranchissementDestinationAdapterConfig', {
  name : 'ComplementServiceAffranchissementDestination',
  fields : [
    {
    	local   : 'code',
    	distant : 'code'
    }, {
    	local   : 'code_service',
    	distant : 'code_service'
    }, {
    	local   : 'code_destination',
    	distant : 'code_destination'
    }, {
    	local   : 'code_affranchissement',
    	distant : 'code_affranchissement'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
})
